import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            内容分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            五大内容板块，从不同维度带你深入了解人渣游戏
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const count = articles.filter((a) => a.category === cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 rounded-lg border border-background-200/70 p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${cat.icon} text-xl`} />
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {cat.description}
                </p>
                <span className="text-xs font-label text-primary-600 flex items-center gap-1 whitespace-nowrap">
                  {count} 篇文章 <i className="ri-arrow-right-line" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}